export const TAB_KEY = 9;
export const SHIFT_KEY = 16;
export const ENTER_KEY = 13;
export const SPACEBAR_KEY = 32;
export const ESCAPE_KEY = 27;
export const ARROW_LEFT_KEY = 37;
export const ARROW_UP_KEY = 38;
export const ARROW_RIGHT_KEY = 39;
export const ARROW_DOWN_KEY = 40;


/** WEBPACK FOOTER **
 ** ./src/constants/keyboardConstants.js
 **/